//Core
import React, {FC} from "react"
//Styles
import {FlexColumn} from "@/styles/layout/boxes"
import {PixelStatusBox, SideBarButtonBox} from "./SideBarButtons.styles";
import {SideBarText} from "../../SideBar.styles";
//Hooks
import {useSideBarButtons} from "./useSideBarButtons"
//Images
import {SideBarImages} from "../../img/buttonImgs";
//Data
import {MainTitlesText} from "@/data/mainTitlesText";
import {buttons, PixelStatusSvg} from "./SideBarButtons.data";
//Components
import {PixelStatusTooltip} from "./tooltip/PixelStatusTooltip.styles";
import {PixelStatusTooltipTitle} from "./tooltip/PixelStatusTooltipTitle";

const SideBarButtons: FC = () => {
    const {activePath, openPage, pixelStatus, isAuthenticated} = useSideBarButtons();

    return (
        <FlexColumn mt={'5.7rem'}>
            {buttons.map((button, i) => {
                    const active = activePath === button;
                    return (
                        <SideBarButtonBox
                            key={button + i}
                            active={active}
                            onClick={() => openPage(button)}
                            // disabled={!isAuthenticated}
                        >
                            {button === 'pixel' && activePath !== 'pixel' && isAuthenticated &&
                                <PixelStatusTooltip title={<PixelStatusTooltipTitle/>}>
                                    <PixelStatusBox>{PixelStatusSvg[pixelStatus]()}</PixelStatusBox>
                                </PixelStatusTooltip>
                            }
                            {SideBarImages[button](active)}
                            <SideBarText active={active}>{MainTitlesText[button]}</SideBarText>
                        </SideBarButtonBox>
                    )
                }
            )}
        </FlexColumn>
    )
}

export default SideBarButtons